import React from "react";

import "./ConsentDocument.css";

const ConsentDocument = props => {
  return (
    <div id="ConsentContainer">
      <h2>INFORMED CONSENT</h2>
      <h2>How do Linear vs. Non-linear vs. hybrid representations of text affect scientific reading comprehension?</h2>
      <h2>HUM00201762</h2>

      <h3>Principal Investigator</h3>
      <p>
        <strong>Iman YeckehZaare</strong>, Ph.D. Candidate, University of Michigan, School of Information
      </p>

      <h3>Faculty Advisor</h3>
      <p>
        <strong>Paul Resnick</strong>, Michael D. Cohen Collegiate Professor of Information and Associate Dean for
        Research and Faculty Affairs, University of Michigan School of Information
      </p>

      <h3>Research Team</h3>
      <ul>
        <li>
          <strong>Alexandra Christi Bateman</strong>, currently working toward her BS in psychology from Creighton
          University's honors program.
        </li>
        <li>
          <strong>Amelia Henriques</strong>, Bachelor of Arts in Psychological Sciences and Human Development &amp;
          Family Sciences, University of Connecticut, College of Liberal Arts and Sciences
        </li>
        <li>
          <strong>Amy Deng</strong>, Undergraduate at University of Michigan, School of Information
        </li>
        <li>
          <strong>Benjamin Brown</strong>, Graduate student at San Jose State University, School of Information
        </li>
        <li>
          <strong>Cynthia Lee</strong>, Bachelor of Science in Psychology &amp; Cognitive Science, University of
          Michigan, School of Information
        </li>
        <li>
          <strong>Ellie Bossenberger</strong>, Undergraduate in Psychology at Oakland University, Auburn Hills, MI
        </li>
        <li>
          <strong>Ember Shan</strong>, Undergraduate at University of Michigan, School of Information
        </li>
        <li>
          <strong>Ethan Hiew</strong>, Undergraduate in Cognitive Science (with a Computational Emphasis) at University
          of California, Davis
        </li>
        <li>
          <strong>Huijia Zheng</strong>, Undergraduate in Psychology and Cognitive Science Major, and Computer Science
          Minor, at University of Michigan, Ann Arbor
        </li>
        <li>
          <strong>Jiayue Mao</strong>, Undergraduate at Rice University
        </li>
        <li>
          <strong>Jinjin Cai</strong>, Undergraduate at Indiana University Bloomington, Department of Psychology, and
          The Media School
        </li>
        <li>
          <strong>Joey Lin</strong>, Bachelor of Science in Neuroscience and Behavior at Vassar College
        </li>
        <li>
          <strong>Leah ONeill</strong>, Undergraduate at Roosevelt University
        </li>
        <li>
          <strong>Lily Margaret DiBartolomeo</strong>, currently a rising senior receiving a BA in Psychology from NYU
        </li>
        <li>
          <strong>Louwis Truong</strong>, Bachelor of Science in Biology, University of Colorado Denver, College of
          Liberal Arts and Sciences
        </li>
        <li>
          <strong>Nandini Valluru</strong>, Undergraduate at University of Michigan, Cognitive Science
        </li>
        <li>
          <strong>Qiaochu Kang</strong>, Master of Science in Information at New York University, Tandon School of
          Engineering
        </li>
        <li>
          <strong>Rehana Naik Olson</strong>, B.A. in Psychology Carleton College, Northfield, MN
        </li>
        <li>
          <strong>Roman Zapata</strong>, M.S. in Human-Computer Interaction DePaul University
        </li>
        <li>
          <strong>Shaobo Liang</strong>, Undergraduate in Cognitive Science, Computer Science, and Philosophy at Johns
          Hopkins University
        </li>
        <li>
          <strong>Shivani Lamba</strong>, Shivani Lamba, Bachelor's of Science in Psychology, Loyola University Chicago,
          College of Arts and Sciences
        </li>
        <li>
          <strong>Sit Wai Phonn</strong>, Master's of Art in Applied Social Psychology, Division of Behavioral and
          Organizational Science, School of Social Science, Policy and Evaluation, Claremont Graduate University
        </li>
        <li>
          <strong>Tirdad Barghi</strong>, Master's of Electrical Engineering, Independent researcher
        </li>
        <li>
          <strong>Xiaowen Yuan</strong>, Undergraduate in Cognitive Science and Computer Science at University of
          California, Berkeley
        </li>
        <li>
          <strong>Yi Cui</strong>, Master's student at the University of Michigan, School of Information
        </li>
        <li>
          <strong>Yizhou Chao</strong>, Master's student at Columbia University, Department of Economics
        </li>
        <li>
          <strong>Ziyi (Hilda) Wang</strong>, Master's student at the University of Michigan, School of Information
        </li>
        <li>
          <strong>Zoe Dunnum</strong>, Undergraduate at Michigan State University
        </li>
      </ul>

      <p>
        You are invited to participate in a research study to investigate the effect of different knowledge
        visualization formats on reading comprehension and learning.
      </p>
      <p>
        In order to participate in the study, you must have access to a laptop or desktop computer with fast and
        reliable internet connection.
      </p>
      <p>
        If you agree to be part of the research study, you will be asked to attend a recorded one-on-one online
        interview session where the interviewer asks the interviewee to share their screen to show them how they answer
        different types of questions on our experiment webpage and explain their answers to each question.
      </p>
      <p>This study includes three sessions:</p>
      <ul>
        <li>The first session takes approximately an hour</li>
        <li>The second session takes approximately 30 minutes</li>
        <li>The third session takes approximately 30 minutes</li>
      </ul>
      <p>
        There are no risks, however, you will be asked to share your screen to present how you read the passages and
        answer questions, and talk throughout the recorded interview.
      </p>
      <p>There is no compensation for participation in this research.</p>
      <p>
        Participating in this study is completely voluntary. Even if you decide to participate now, you may change your
        mind and stop at any time. You may choose not to answer any or request to pause or stop the interview for any
        reason.
      </p>
      <p>We will not collect any sensitive or identifiable information.</p>
      <p>
        Information collected in this project may be shared with other researchers, but we will not share any
        information that could identify you.
      </p>
      <p>If you have questions about this research study, please contact:</p>
      <p>Principal Investigator: Iman YeckehZaare</p>
      <p>Email: oneweb@umich.edu</p>
      <p>Phone: (+1) (734) 647-6333</p>
      <p>Faculty Advisor: Paul Resnick</p>
      <p>Email: presnick@umich.edu</p>
      <p>
        As part of their review, the University of Michigan Institutional Review Board Health Sciences and Behavioral
        Sciences has determined that this study is no more than minimal risk and exempt from ongoing IRB oversight.
      </p>
    </div>
  );
};

export default ConsentDocument;
